import type { JSX } from "react";

import { Stack, Text } from "@mantine/core";

import classes from "../chat-components.module.css";

export const IncomingChatCopy = (): JSX.Element => {
    return (
        <Stack className={classes.incoming_chat_copy}>
            <Text span fw="bold" size="xs">
                Pending chat
            </Text>
            <Text span size="xxs">
                Waiting on reply...
            </Text>
        </Stack>
    );
};
